import React from 'react';
import PropTypes from 'prop-types';

const Metric = ({ label, value, hint }) => (
    <div>
        <div className="text-muted small">{label}</div>
        <div className="fs-5 fw-semibold">{value}</div>
        {hint && <div className="text-muted small">{hint}</div>}
    </div>
);

Metric.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    hint: PropTypes.string
};

export default Metric;
